import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { AuthState, AuthStore } from '@store';

@Injectable()
export class AuthGuardService {
  constructor(private authStore: AuthStore, private router: Router) {}

  canActivate(): Observable<boolean> {
    return this.checkAuth();
  }

  private checkAuth(): Observable<boolean> {
    return combineLatest([this.authStore.state$, this.authStore.isEndUserWithoutAccess$]).pipe(
      filter(([state]) => !state.authenticating),
      map(([state, isEndUserWithoutAccess]: [AuthState, boolean]) => {
        if ((!state.authorized && !state.authorizing) || isEndUserWithoutAccess) {
          this.router.navigate(['/home']);
        }

        if (state.authorized && !state.authorizing) {
          return true;
        }
      })
    );
  }
}
